import React from 'react';
import classNames from 'classnames';
import { has, map, reduce } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { checkbox as Checkbox } from 'ui/views/generic/checkbox';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { cardFilter as CardFilter } from 'ui/views/widgets/cardFilter';
 *
 * // render
 * <CardFilter propName='propValue'/>
 */
export const cardFilter = ( { className, cards, value, data, onChange } ) => {
    const widgetClassName = classNames( className, 'ui-card-filter' );

    return (
        <div className={ widgetClassName }>
            {
                map( cards, card => {
                    const totalCount = reduce( data.values, ( sum, count ) => sum + count );
                    const count = has( data.values, card.name ) ? data.values[ card.name ] : totalCount;

                    const cardName = card.name;

                    const isCardSelected = value === cardName;

                    const cardClassName = classNames( 'ui-card-filter__filter', {
                        'ui-card-filter__filter--selected': isCardSelected
                    } );

                    let customizedRequestData = {};

                    // In case of `allPriorAuthItems` empty string
                    // needs to be sent as status in requestData
                    if ( 'allPriorAuthItems' === cardName ) {

                        customizedRequestData = {
                            status: ''
                        };
                    }

                    return (
                        <div key={ cardName } className={ cardClassName }>
                            <div className='ui-card-filter__filter__icon'>
                                <Icon id={ cardName } />
                            </div>
                            <div className='ui-card-filter__filter__info'>
                                <div className='ui-card-filter__filter__info__title'>
                                    { getLabel( card.title ) }
                                </div>
                                <div className='ui-card-filter__filter__info__count'>
                                    { count }
                                </div>
                            </div>
                            <div
                                className='ui-card-filter__filter__checkbox'
                                onClick={ () => onChange( cardName, customizedRequestData ) }
                            >
                                <Checkbox
                                    name={ cardName }
                                    value={ isCardSelected }
                                />
                            </div>
                        </div>
                    );
                } )
            }
        </div>
    );
};

// set display name
cardFilter.displayName = 'cardFilter';

// set default props
cardFilter.defaultProps = {};

// prop types
cardFilter.propTypes = {};
